import { useQuery } from "@tanstack/react-query"
import { getBackofficeCapabilityExecutionsAnalyticsQuery } from "modules/backoffice/lib/capabilityExecutions/getBackofficeCapabilityExecutionsAnalyticsQuery"

export function useGetBackofficeCapabilityExecutionsAnalyticsQuery(
  ...args: Parameters<typeof getBackofficeCapabilityExecutionsAnalyticsQuery>
) {
  return useQuery(getBackofficeCapabilityExecutionsAnalyticsQuery(...args))
}
